<div class="dialog-content-wrapper">
    <form [formGroup]="eventForm" fxLayout="column" fxLayoutAlign="start" fxFlex="1 0 auto">
        <mat-toolbar matDialogTitle class="mat-accent m-0">
            <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
                <span class="title dialog-title">
                    <span *ngIf="!editMode">
                        {{'Visit'|translate}}: {{ event.startDate|date: 'dd.MM.y':'UTC': locale }}
                        <b>{{ event.startDate|date: 'HH:mm':'UTC':locale }} - {{ event.endDate|date: 'HH:mm': 'UTC': locale }}</b>
                    </span>
                    <span *ngIf="editMode">
                        {{'Visit'|translate}}:
                        <mat-form-field appearance="fill">
                          <input matInput [matDatepicker]="picker" formControlName="date" (dateChange)="onDateChange($event)">
                          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>

                        <mat-form-field appearance="fill" style="width:100px;">
                            <mat-select formControlName="startHour">
                                <mat-option [value]="hour" *ngFor="let hour of hours">
                                    {{ hour }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        -

                        <mat-form-field appearance="fill" style="width:100px;">
                            <mat-select formControlName="endHour">
                                <mat-option [value]="hour" *ngFor="let hour of hours">
                                    {{ hour }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </span>
                </span>
                <button *ngIf="!editMode" mat-icon-button (click)="matDialogRef.close()" aria-label="Close dialog">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-toolbar-row>
        </mat-toolbar>

        <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
            <table>
                <tr *ngIf="event.customer">
                    <th style="text-align: left; width: 150px;">{{ 'Customer'|translate }}</th>
                    <td style="width: 550px;"><a
                            style="cursor: pointer;"
                            (click)="showCustomerContactDetails(event.customer)">{{ event.customer.firstName }} {{ event.customer.lastName }}
                        ; {{ event.customer.phone }}</a>

                        &nbsp;&nbsp;&nbsp;<a
                                style="cursor: pointer;"
                                (click)="matDialogRef.close()"
                                matRipple routerLink="/customers/personal-data/{{event.customer.id}}" [routerLinkActive]="[]"
                        >
                            [Przejdź do klienta]
                        </a>
                    </td>
                </tr>
                <tr *ngIf="event.groupActivity">
                    <th style="text-align: left; width: 150px;">{{ 'Trainer'|translate }}</th>
                    <td style="width: 550px;">{{ event.groupActivity.trainer.firstName }} {{ event.groupActivity.trainer.lastName }}
                        ; {{ event.groupActivity.trainer.phone }}</td>
                </tr>
                <tr *ngIf="event.groupActivity">
                    <th style="text-align: left; width: 150px;">{{ 'Number of contestants'|translate }}</th>
                    <td style="width: 550px;" (click)="displayParticipantsList(event)" style="cursor: pointer; color: deepskyblue;">{{ event.groupActivity.participants?event.groupActivity.participants.length:'0' }}</td>
                </tr>
                <tr *ngIf="event.groupActivity">
                    <th style="text-align: left; width: 150px;">{{ 'Add contestants'|translate }}</th>
                    <td style="width: 550px;">
                        <form fxLayout="column" fxLayoutAlign="start"
                              fxFlex="1 0 auto" name="form" [formGroup]="form">
                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                <mat-form-field appearance="outline" fxFlex="70">
                                    <mat-label>{{'Customer'|translate}}</mat-label>
                                    <input type="text"
                                           placeholder="{{ 'Customer'|translate }}"
                                           matInput
                                           formControlName="customer"
                                           [matAutocomplete]="auto">
                                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn">
                                        <mat-option [value]="customer" *ngFor="let customer of filteredOptions|async">
                                            {{customer.firstName}} {{customer.lastName}}; {{customer.phone}}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                                <button
                                        *ngIf="!adding"
                                        fxFlex="30"
                                        mat-button
                                        class="mr-8"
                                        (click)="addCustomerToTraining(form)"
                                        aria-label="Add"
                                        color="primary"
                                >
                                    {{'Add'|translate}}
                                </button>
                                <button
                                        *ngIf="adding"
                                        fxFlex="30"
                                        mat-button
                                        class="mr-8"
                                        disabled
                                        aria-label="Add"
                                        color="primary"
                                >
                                    {{'Add'|translate}}
                                </button>
                            </div>
                        </form>
                    </td>
                </tr>
                <tr *ngIf="!editMode">
                    <th style="text-align: left;">{{ 'Start date'|translate }}</th>
                    <td>{{ event.startDate|date: 'dd.MM.y HH:mm':'UTC': locale }}</td>
                </tr>
                <tr *ngIf="!editMode">
                    <th style="text-align: left;">{{ 'End date'|translate }}</th>
                    <td>{{ event.endDate|date: 'dd.MM.y HH:mm': 'UTC': locale }}</td>
                </tr>
                <tr>
                    <th style="text-align: left;">{{ 'Service'|translate }}</th>
                    <td>
                        <span *ngIf="!editMode && event.service">
                            {{ event.service.name }}
                        </span>

                        <span *ngIf="editMode">
                            <mat-form-field appearance="outline" fxFlex="100">
                                <mat-select formControlName="service" (ngModelChange)="getResourceGroups(eventForm.get('service').value)">
                                    <mat-option [value]="null">

                                    </mat-option>
                                    <mat-option [value]="service.id" *ngFor="let service of services">
                                        {{service.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </span>
                    </td>
                </tr>
                <tr *ngIf="event.reservedUsers">
                    <th style="text-align: left;">{{ 'Worker'|translate }}</th>
                    <td>{{ event.reservedUsers[0].firstName }} {{ event.reservedUsers[0].lastName }}</td>
                </tr>
                <tr *ngIf="event.reservedResources">
                    <th style="text-align: left; vertical-align: top;">{{ 'Resources'|translate }}</th>
                    <td>
                        <ul *ngIf="!editMode">
                            <li *ngFor="let resource of event.reservedResources">{{ resource.name }}</li>
                        </ul>
                        <ul *ngIf="editMode">
                            <form [formGroup]="eventForm" fxLayout="column" fxLayoutAlign="start"
                                  fxFlex="1 0 auto">
                                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" formArrayName="reservedResources" *ngFor="let group of groups; index as i;">
                                    <mat-form-field appearance="outline" fxFlex="100" *ngIf="eventForm.get('service').value" [formGroupName]="i">
                                        <mat-label>{{'Resource'|translate}}</mat-label>

                                        <mat-select formControlName="id" required>
                                            <mat-option [value]="null">

                                            </mat-option>
                                            <mat-option [value]="resource.id" *ngFor="let resource of group.resources">
                                                {{resource.name}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </form>
                        </ul>
                    </td>
                </tr>
                <tr>
                    <th style="text-align: left;">{{ 'Description'|translate }}</th>
                    <td>
                        <span *ngIf="!editMode">{{ event.description }}</span>
                        <span *ngIf="editMode">
                            <textarea matInput formControlName="description" class="textarea"></textarea>
                        </span>
                    </td>
                </tr>
            </table>
        </div>
    </form>
    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button *ngIf="!editMode"
                mat-button
                class="mr-8"
                aria-label="Delete"
                (click)="showConfirmEventDeleteDialog(event)"
        >
            {{'DELETE'|translate}}
        </button>

        <button *ngIf="editMode"
                mat-button
                class="mr-8"
                aria-label="Cancel"
                (click)="editMode = false"
        >
            {{'CANCEL'|translate}}
        </button>

        <button *ngIf="event.groupActivity"
                mat-button
                class="save-button"
                color="primary"
                aria-label="Edit"
                (click)="event.groupActivity?goToGroupActivityDetails(event):''; editMode = false; matDialogRef.close();"
        >
            {{'DETAILS'|translate}}
        </button>

        <button *ngIf="!editMode"
                mat-button
                class="save-button"
                color="primary"
                aria-label="Edit"
                (click)="event.service?getResourceGroups(event.service.id):''; editMode = true"
        >
            {{'EDIT'|translate}}
        </button>

        <button *ngIf="editMode"
                mat-button
                class="save-button"
                color="primary"
                aria-label="Edit"
                (click)="matDialogRef.close(eventForm)"
        >
            {{'SAVE'|translate}}
        </button>

        <button *ngIf="!event.completed && event.service && !event.groupActivity" (click)="confirmExercise(event.customer, event.service); $event.stopPropagation()" mat-button="filled" class="mr-8" color="primary"><b style="color: green;">Zrealizuj</b></button>

    </div>
</div>
